'use client';

import { c as _c } from "react/compiler-runtime";
import { CartCurrencyProvider } from '@feat/feat-cart/currency';
import { UrlStateProvider } from '@feat/feat-url-state/provider';
import type { UrlState } from '@feat/feat-url-state/schema';
import type { DehydratedState } from '@tanstack/react-query';
import { HydrationBoundary } from '@tanstack/react-query';
import { ExperienceFilterProvider } from 'src/app/erlebnisse/_components/app-experience-filter-provider';
import { AppExperienceOffers } from 'src/app/erlebnisse/_components/app-experience-offers';
import type { ExperienceFilter } from 'src/app/erlebnisse/_lib/experience-state-types';
import type { NexperienceForChoicesQuery } from 'src/lib/backend/documents/experience';
type ExperienceChoices = NonNullable<NexperienceForChoicesQuery['nexperience']>;
type ExperienceChoicesPageClientProps = {
  experience: ExperienceChoices;
  initialFilter: ExperienceFilter;
  initialUrlState: UrlState;
  dehydratedState: DehydratedState;
  cartCurrency: string | null;
};
export function ExperienceChoicesPageClient(t0) {
  const $ = _c(13);
  const {
    experience,
    initialFilter,
    initialUrlState,
    dehydratedState,
    cartCurrency
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AppExperienceOffers />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== cartCurrency) {
    t2 = <CartCurrencyProvider cartCurrency={cartCurrency}>{t1}</CartCurrencyProvider>;
    $[1] = cartCurrency;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== experience || $[4] !== initialFilter || $[5] !== t2) {
    t3 = <ExperienceFilterProvider key={experience.id} experience={experience} initialFilter={initialFilter} urlStateEnabled={true}>{t2}</ExperienceFilterProvider>;
    $[3] = experience;
    $[4] = initialFilter;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== dehydratedState || $[8] !== t3) {
    t4 = <HydrationBoundary state={dehydratedState}>{t3}</HydrationBoundary>;
    $[7] = dehydratedState;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== initialUrlState || $[11] !== t4) {
    t5 = <UrlStateProvider defaultValue={initialUrlState} initialUrlSync={true}>{t4}</UrlStateProvider>;
    $[10] = initialUrlState;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}